export const STANDALONE_LANGUAGE_CONST = {
  storage: {
    languageOverride: 'StandaloneLanguageOverride',
  },
} as const;

export const STANDALONE_LANGUAGE_LABELS: Readonly<Record<string, string>> = {
  'en-US': 'English (US)',
  'es-ES': 'Español',
  'fr-FR': 'Français',
  'de-DE': 'Deutsch',
  'it-IT': 'Italiano',
};
